module.exports = __webpack_public_path__ + "img/d7.7ab0f619.png";